import { render } from "./AttendeeSelectModal.vue?vue&type=template&id=4dfeb486&scoped=true"
import script from "./AttendeeSelectModal.vue?vue&type=script&lang=js"
export * from "./AttendeeSelectModal.vue?vue&type=script&lang=js"

import "./AttendeeSelectModal.vue?vue&type=style&index=0&id=4dfeb486&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfeb486"]])

export default __exports__